function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import Comments from '../svgs/components/comments';

var CommentButton = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CommentButton, _React$Component);

  function CommentButton(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.getMobileEnabledClick = _this.getMobileEnabledClick.bind(_assertThisInitialized(_this));
    _this.getCommentsCounter = _this.getCommentsCounter.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = CommentButton.prototype;

  _proto.getMobileEnabledClick = function getMobileEnabledClick(action) {
    return this.props.isMobile ? {
      onTouchEnd: action
    } : {
      onClick: action
    };
  };

  _proto.getCommentsCounter = function getCommentsCounter() {
    return this.props.commentsCounter;
  };

  _proto.render = function render() {
    var commentsCounter = this.getCommentsCounter();
    return commentsCounter ? /*#__PURE__*/React.createElement("span", {
      className: 'info-member info-element-social-comments info-element-social-button',
      "data-hook": "comments-button",
      tabIndex: -1,
      role: "checkbox",
      "aria-checked": this.props.isLoved,
      "aria-label": 'Comments'
    }, /*#__PURE__*/React.createElement(Comments, {
      className: "info-element-social-comments-icon"
    }), /*#__PURE__*/React.createElement("div", {
      className: "info-element-social-comments-count"
    }, commentsCounter)) : /*#__PURE__*/React.createElement("div", null);
  };

  return CommentButton;
}(React.Component);

export default CommentButton;